import { FoodItem } from "../../types"
import { RawCategory, descendantTypes } from "./categories"

/*
 * Pure helpers — these used to call useStateValue() internally and were invoked
 * from inside a JSX ternary, which made the hook call conditional and changed
 * the parent's hook order between renders. They take their data as arguments
 * instead.
 */

/** Products in a category, including everything under its sub-categories. */
export const FilterFood = (
    foodItems: FoodItem[],
    categories: RawCategory[],
    category: string
) => {
    const types = descendantTypes(categories || [], category)
    return (foodItems || []).filter((item: FoodItem) => types.has(item.category))
}

export const GetFoodById = (foodItems: FoodItem[], id: number) =>
    (foodItems || []).find((item: FoodItem) => item.id === id)
